import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade,Navigation,Thumbs,Pagination } from 'swiper';
import React, { useState, useEffect, useRef } from 'react';
import api from '../../interceptor/axios';
import 'swiper/swiper-bundle.css';
import { Toast } from 'primereact/toast';

SwiperCore.use([EffectFade,Navigation,Thumbs,Pagination]);

const SelectorCiudad = ({ onSeleccionarCiudad }) => {

  const toast = useRef(null);
  const [ciudades, setCiudades] = useState(null);

  const seleccionar = (datosCiudad) => {
    onSeleccionarCiudad(datosCiudad);
  };

  useEffect(() => {
    
    api.post(process.env.REACT_APP_REST_URL + '/callejero/obtenerCiudades.php', {})
      .then(response => {
          if(response.data.success !== true){
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
          } else {
            setCiudades(response.data.ciudades);
          }
      })
      .catch(error => {
         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
      });
  }, []);



  return (
    <div className="container-frontal">
      <Toast ref={toast} />
      <h2>Selecciona una ciudad</h2>
      <Swiper  
            breakpoints={{
                320: { slidesPerView: 1 },
                550: { slidesPerView: 2 },
                991: { slidesPerView: 3 },
                1400: { slidesPerView: 4 }
            }}
            loop={false}  
            slidesPerView={1} 
            spaceBetween={20}  
            as="ul" 
            className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction">

              {ciudades && ciudades.map((ciudad) => (
                <>
                  <SwiperSlide as="li"  onClick={() => seleccionar(ciudad)} className='enlace'>
                    <div className=" block-images position-relative">
                        <div className="img-box">
                              <img src={process.env.REACT_APP_ESTATICOS_URL + "callejero/" + ciudad.ID + ".jpg"} className="img-fluid portada-tema" alt=""/>
                        </div>
                        <div className="block-description titulo-tema mt-4">
                              <h6 className="iq-title enlace">{ciudad.nombre}</h6>
                        </div>
                    </div>
                  </SwiperSlide> 
                </>
              ))}
        </Swiper>
    </div>
  );
};

export default SelectorCiudad;
